import { render, staticRenderFns } from "./LgFinderPageContrato.vue?vue&type=template&id=532ff15e"
import script from "./LgFinderPageContrato.vue?vue&type=script&lang=js"
export * from "./LgFinderPageContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports